// extracted by mini-css-extract-plugin
export default {"expensesHeader":"OtherExpensesEditor-module__expensesHeader___tFWiI","label":"OtherExpensesEditor-module__label___QWug1"};